import { performTokenRefresh } from './sdk-client';

export type EnsureSessionResult =
  | {
      status: 'valid';
      accessToken: string;
      refreshToken: string;
      expiresIn: number;
    }
  | { status: 'expired' }
  | { status: 'superseded' }
  | { status: 'blocked' }
  | { status: 'error'; message: string };

export type EnsureSessionOptions = {
  refreshToken: string;
  deviceFingerprint?: string;
};

export async function ensureValidSession(
  options: EnsureSessionOptions,
): Promise<EnsureSessionResult> {
  const { refreshToken, deviceFingerprint } = options;

  // Delegates to the shared single-flight refresh so that the cold-start
  // bootstrap and any concurrent 401-triggered refresh never race with the
  // same rotating refresh token (which would falsely look "superseded").
  return performTokenRefresh(refreshToken, deviceFingerprint);
}
